import React from 'react';
import Label from './Label';
import { inputClassWithError } from '../../styles/forms';

function FormField({
  id,
  label,
  required = false,
  error,
  hint,
  className = '',
  children,
  inputClassName = '',
  asChild = false,
}) {
  const errorId = error ? `${id}-error` : undefined;
  const hintId = hint ? `${id}-hint` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={className}>
      {label ? (
        <Label htmlFor={id} required={required}>
          {label}
        </Label>
      ) : null}

      {asChild ? (
        <>
          {children}
          {error ? (
            <p id={errorId} role="alert" className="mt-1.5 text-xs font-medium text-error-600 ">
              {error}
            </p>
          ) : null}
        </>
      ) : (
        React.Children.map(children, (child) => {
          if (!React.isValidElement(child)) return child;
          return React.cloneElement(child, {
            id: child.props.id || id,
            'aria-invalid': error ? true : undefined,
            'aria-describedby': describedBy,
            className: `${inputClassWithError(Boolean(error), child.props.className || inputClassName)}`.trim(),
          });
        })
      )}

      {hint && !error ? (
        <p id={hintId} className="mt-1.5 text-xs text-secondary-500 ">
          {hint}
        </p>
      ) : null}

      {error ? (
        <p id={errorId} role="alert" className="mt-1.5 text-xs font-medium text-error-600 ">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export default FormField;
